<template>
  <path
    d="M14.71 6.71022C14.32 6.32022 13.69 6.32022 13.3 6.71022L8.71001 11.3002C8.32001 11.6902 8.32001 12.3202 8.71001 12.7102L13.3 17.3002C13.69 17.6902 14.32 17.6902 14.71 17.3002C15.1 16.9102 15.1 16.2802 14.71 15.8902L10.83 12.0002L14.71 8.12022C15.1 7.73022 15.09 7.09022 14.71 6.71022Z"
  />
</template>
